<template>
  <div>
    <ListItemFilters
      icon="ui-icon-clock"
      :title="title || t('Время работы', options)"
      :subtitle="title ? t('Время работы', options) : undefined"
      @click="openDialog"
    />

    <v-overlay
      :value="isDialogOpened"
      @click="closeDialog"
    />
    <v-bottom-sheet
      :value="isDialogOpened"
      :width="isMobile ? undefined : 400"
      attach=".vue-the-lpu-filters .v-application"
      content-class="ml-auto rounded-0"
      hide-overlay
      @input="closeDialog"
    >
      <v-card
        tile
        class="py-4"
      >
        <div class="text-h6 px-4 pt-2 mb-2">
          {{ t('Время работы', options) }}
        </div>
        <TimeWorkSelector
          v-model="lpuFiltersState"
          class="px-4"
        />
        <div class="px-2 mt-4">
          <v-btn
            block
            depressed
            color="primary"
            :disabled="!hasUnsavedTimeWork"
            @click="handleApply"
          >
            {{ t('Применить', options) }}
          </v-btn>
        </div>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import I18NextVue from 'i18next'
import deepClone from 'www/vue_components/common/TheFilters/lpu/functions/deepClone'
import deepEqual from 'www/vue_components/common/TheFilters/lpu/functions/deepEqual'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import getTimeWorkLabel from 'www/vue_components/common/TheFilters/lpu/components/TimeWorkFilters/functions/getTimeWorkLabel'
import ListItemFilters from 'www/vue_components/common/TheFilters/common/components/ListItemFilters/ListItemFilters.vue'
import TimeWorkSelector from 'www/vue_components/common/TheFilters/lpu/components/TimeWorkFilters/components/TimeWorkSelector/TimeWorkSelector.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore.types'

const isMobile = window.MOBILE_VERSION

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()

const filtersStore = useFiltersStore()

const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ListItemTimeWork')

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const lpuFiltersState = ref(deepClone(props.value))
const resetLpuFiltersState = () => {
  lpuFiltersState.value = deepClone(filtersStore.unsavedFilters)
}

watch(() => isDialogOpened.value, resetLpuFiltersState)

const title = computed(() => t(getTimeWorkLabel({
  timeWork: filtersStore.unsavedFilters.timeWork,
}) || '', options.value))

const hasUnsavedTimeWork = computed(() => (
  !deepEqual(lpuFiltersState.value.timeWork, filtersStore.unsavedFilters.timeWork)
))

const handleApply = () => {
  closeDialog()

  filtersStore.updateUnsavedFilters(lpuFiltersState.value)
  emit('input', filtersStore.unsavedFilters)
}
</script>
